import React from "react";
import data from "./ListData.json";
import datap from "../asset/dataex.png";
import { Link } from "react-router-dom";


const List = (props) => {
  const filteredData = data.filter((el) => {
    if (props.input === "") {
      return el;
    } else {
      return el.text.toLowerCase().includes(props.input);
    }
  });
  return (
    <>
      <div className="row row-cols-1 row-cols-md-3 g-4 my-5" style={{flexDirection:"row"}}>
        {filteredData.map((item) => (
          <div className="col">
            <Link to={item.link}>
            <div className="card-100">
              <img src={datap} className="card-img-top h-50" alt="Working"/>
              <div className="card-body">
                <h5 className="card-title text-center text-light">{item.text}</h5>
              </div>
            </div>
            </Link>
          </div>
      
        ))}
      </div>
    </>
    );
};

export default List;
